import { Button, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import identityIconGlyph from "Assets/newicons/app/profile/glyph/identity-glyph-16px.svg";
import otherDocumentsIconGlyph from "Assets/newicons/app/profile/glyph/other-data-glyph-16px.svg";
import identityIconOutline from "Assets/newicons/app/profile/outline/identity-outline-16px.svg";
import otherDocumentsIconOutline from "Assets/newicons/app/profile/outline/other-data-outline-16px.svg";
import get from "lodash/get";
import React from "react";
import Dropzone from "react-dropzone";
import { FormattedMessage } from "react-intl";
import {
  downloadFile,
  instance,
  instanceMultipart,
} from "../../../../Actions/AxiosInstance";
import addRoundFilledBlue from "../../../../Assets/newicons/action/add-round/glyph/add-round-filled-blue-16px.svg";
import walletIcon from "../../../../Assets/Svg/wallet.svg";
import If from "../../../../Component/Common/If";
import DynamicForm from "../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../Component/DynamicForm/Fields/Select";
import DrawerHeader from "../../../../Component/Headers/drawerHeader";
import LabelIcon from "../../../../Component/Labels/LabelIcon";
import ThumbnailBig from "../../../../Component/Thumbnail/ThumbnailBig";
import { ErrorMessages } from "../../../../Constants";
import { getUrlExtension } from "../../../../Handlers/getters";
import { getFormattedImageLink } from "../../../../Utils";
import IdentityDocuments from "./IdentityDocuments";
import OtherDocuments from "./OtherDocuments";

class DocumentationTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DocTypes: [],
      EmpDocsReceived: [],
      received: false,
      drawerStatus: false,
      selectedDoc: "",
      selectedDocType: "",
      selectedUploadDoc: "",
      tabId: 0,
      documentTabs: [
        {
          label: (
            <FormattedMessage
              id="Tabidentitydocuments"
              defaultMessage="Identity"
            />
          ),
          icon: (
            <img src={identityIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
          ),
          id: 0,
          name: "identitydocuments",
        },
        {
          label: (
            <FormattedMessage id="Tabotherdocuments" defaultMessage="Other" />
          ),
          icon: (
            <img
              src={otherDocumentsIconOutline}
              style={{ marginBottom: 0 ,marginRight:8}}
            ></img>
          ),
          id: 1,
          name: "otherdocuments",
        },
      ],
    };
    this.getDocumentListComponent = this.getDocumentListComponent.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.getEmpDocs = this.getEmpDocs.bind(this);
    this.getDocTypes = this.getDocTypes.bind(this);
    this.uploadDocComp = this.uploadDocComp.bind(this);
  }

  componentDidMount() {
    this.getDocTypes();
    this.getEmpDocs();
  }

  getEmpDocs() {
    const URL = "employee/getemployeefile";
    const DATA = {};
    if (this.props.colleagueid) {
      DATA.employeeid = this.props.colleagueid;
    }
    instance
      .post(URL, DATA)
      .then((result) => {
        this.setState({
          EmpDocsReceived: result.data.result,
          received: true,
          selectedDoc: "",
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getDocTypes() {
    const URL = "subscription/countryfiletag";
    instance
      .get(URL)
      .then((res) => {
        this.setState({
          DocTypes: [...res.data.result],
        });
      })
      .catch(() => {
        this.setState({
          DocTypes: [{ displayname: "Select", displayvalue: null }],
        });
      });
  }

  removeFile(docDetails) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            const data = {
              employeefileid: [docDetails.employeefileid],
            };
            instance
              .post("employee/deleteemployeefile", data)
              .then(() => {
                this.getEmpDocs();
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
              })
              .catch((error) => {
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
          }}
        >
          Yes
        </Button>,
        <Button key="2" color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  uploadDoc(files) {
    const file = files[0];
    let extFile;
    if (file) {
      const img = file.name.split(";");
      const imgname = img[0];
      extFile = getUrlExtension(imgname);
      // let idxDot;
      // idxDot = imgname.lastIndexOf(".") + 1;
      // extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    }
    const availableExt = [
      "png",
      "jpg",
      "jpeg",
      "pdf",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "txt",
      "odt",
    ];
    if (availableExt.findIndex((x) => extFile == x) == -1) {
      this.props.enqueueSnackbar("Please upload image or pdf only", {
        variant: "error",
      });
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    const URL = "employee/uploademployeefiles";
    instanceMultipart.post(URL, formData).then((resp) => {
      const fileMetaData = resp.data.result[0];
      this.setState({ selectedUploadDoc: fileMetaData });
    });
  }

  onSave = () => {
    const { selectedUploadDoc, selectedDocType, DocTypes } = this.state;
    const fileMetaData = selectedUploadDoc;
    if (!fileMetaData || !selectedDocType) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    }
    const filename = DocTypes.find((x) => x.displayvalue == selectedDocType);
    const data = {
      employeeid:
        get(this.props, "colleagueid", "") ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      filedata: {
        filedata: [
          {
            employeefileid:
              get(this.props, "colleagueid", "") ||
              get(this.state, "AuthenticationAction.login.employeeid", null),
            filename: filename ? filename.displayvalue : "",
            originalfilename: fileMetaData.originalname,
            fileextension: fileMetaData.extension,
            filesize: fileMetaData.size,
            filepath: fileMetaData.imagepath,
            filetagtypeid: selectedDocType,
            filefortypeid: 1,
          },
        ],
      },
    };
    instance.post("employee/insertupdateemployeefile", data).then((resp) => {
      this.setState(
        { selectedDocType: "", selectedUploadDoc: "", drawerStatus: false },
        () => this.getEmpDocs(),
      );
    });
  };

  downloadDoc = (path) => {
    downloadFile(path);
  };

  getDocumentListComponent() {
    const { EmpDocsReceived = [] } = this.state;
    return (
      <div>
        <div
          className="cursour-pointer"
          onClick={() => this.setState({ drawerStatus: true })}
        >
          <img src={addRoundFilledBlue} className="vertical-middle" />
          <span className="small-blue t-bold margin-left-8">
            Add new document
          </span>
        </div>
        <br />
        {EmpDocsReceived.map((doc) => {
          const cls =
            doc.employeefileid ==
            get(this.state, "selectedDoc.employeefileid", "")
              ? "text-color-blue"
              : "";
          return (
            <div
              key="key"
              className={`${cls} cursour-pointer margin-left-10 margin-top-20`}
              onClick={() => this.setState({ selectedDoc: doc })}
            >
              <LabelIcon
                label={
                  doc.filetagtypeid == 99
                    ? doc.originalfilename
                    : doc.filetagname
                }
                img={walletIcon}
                labelClassNames={cls}
              />
            </div>
          );
        })}
      </div>
    );
  }

  // onEditDoc = () => {
  //   document.getElementById("fileupload").click();
  // };

  uploadDocEdit = (e) => {
    if (get(e, "target.files[0]", "")) {
      const _file = e.target.files[0];
      this.uploadDoc([_file]);
    }
  };

  onDeleteDoc = () => {
    this.setState({ selectedUploadDoc: "" });
  };

  uploadDocComp() {
    const {
      DocTypes,
      selectedDocType,
      selectedUploadDoc,
      EmpDocsReceived = [],
    } = this.state;

    return (
      <div className="planner-right-drawer">
        {/* <span
          onClick={() => this.setState({ drawerStatus: false })}
          className="drawer-close-btn margin-bottom-14 margin-top-4"
        >
          <img src={cancelIcon} />
        </span>
        <span className="drawer-header  margin-bottom-14">Upload new document</span> */}

        <DrawerHeader
          header="Upload new document"
          isbackarrow={false}
          closeDrawer={() => this.setState({ drawerStatus: false })}
        />

        <DynamicForm
          className="margin-20 margin-top-20"
          fields={selectinputconverter({
            options: DocTypes.filter(
              (x) =>
                EmpDocsReceived.findIndex(
                  (y) => y.filetagtypeid == x.displayvalue,
                ) == -1 || x.displayvalue == 99,
            ),
            value: selectedDocType,
            label: "Document type",
            placeholder: "Select tag for this document",
          })}
          onChange={(val) => this.setState({ selectedDocType: val })}
        />
        <br />
        <Grid container>
          {selectedUploadDoc ? (
            <Grid md="12">
              {/* <input id="fileupload" type="file" name="Upload Emploxyee Data" onChange={(e) => this.uploadDocEdit(e)} hidden /> */}
              <ThumbnailBig
                key="key"
                onDelete={this.onDeleteDoc}
                onEdit={this.uploadDoc}
                filetypes="image/*,.pdf,.ppt,.pptx,.doc,.docx,.txt,.odt"
                doc={{
                  url: getFormattedImageLink(selectedUploadDoc.imagepath),
                }}
              />
            </Grid>
          ) : (
            <Tooltip title="Add attachment" placement="right">
              <Dropzone
                onDrop={(e) => this.uploadDoc(e)}
                multiple={false}
                accept="image/*,.pdf,.ppt,.pptx,.doc,.docx,.txt,.odt"
                maxSize={2000000}
                className="drag-drop"
              >
                <Grid md="12">
                  <div className="add-attachment-new">
                    <img src={addRoundFilledBlue}></img>
                  </div>
                </Grid>
              </Dropzone>
            </Tooltip>
          )}

          <br />
          <p className="input-label" style={{paddingLeft: 8}}>
              Note: Upload photo with max size 2 MB for optimum results.
              (Supports .gif, .jpeg, .jpg , .pdf, .ppt, .pptx, .doc, .docx, .txt, .odt and .png file types)
            </p>
          <Grid md="12">
            <Button
              className="btn btn-primary-sm-blue margin-top-20"
              onClick={this.onSave}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  handleMenuChange(selectedId) {
    let { documentTabs } = this.state;
    documentTabs = documentTabs.map((tab) => {
      if (tab.id == 0) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={identityIconGlyph} style={{ marginBottom: 0 , marginRight:8}}></img>
            ) : (
              <img src={identityIconOutline} style={{ marginBottom: 0 , marginRight:8}}></img>
            ),
        };
      } else {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img
                src={otherDocumentsIconGlyph}
                style={{ marginBottom: 0 , marginRight:8 }}
              ></img>
            ) : (
              <img
                src={otherDocumentsIconOutline}
                style={{ marginBottom: 0 , marginRight:8 }}
              ></img>
            ),
        };
      }
    });
    this.setState({ tabId: selectedId, documentTabs });
  }

  render() {
    const { received } = this.state;
    const { tabId } = this.state;
    return (
      <If condition={received}>
        <div
          className="vertical-tab-section"
          style={{
            display: "flex",
            overflowY: Hidden,
            paddingLeft: 0,
            // paddingRight: 0,
          }}
        >
          <VerticalTabs
            value={tabId}
            indicatorColor="primary"
            textColor="primary"
            className="right-border width250 cursurpointer"
          >
            {this.state.documentTabs.map((tab) => (
              <MyTab
                label={tab.label}
                icon={tab.icon}
                onClick={() => this.handleMenuChange(tab.id)}
                className={
                  tab.id == 0
                    ? " IdentityDocuments var-tab-heading"
                    : tab.id == 1
                    ? " OtherDocuments var-tab-heading"
                    : "var-tab-heading"
                }
              />
            ))}
          </VerticalTabs>
          <div
            style={{
              width: 5,
              height: 530,
              background: "#d3d3d3",
              position: "relative",
              left: -4,
              zIndex: -1,
            }}
          ></div>
          {this.state.tabId === 0 && (
            <TabContainer>
              <IdentityDocuments {...this.props} />
            </TabContainer>
          )}
          {this.state.tabId === 1 && (
            <div className="thin-scroll width100">
              <TabContainer>
                <OtherDocuments {...this.props} />
              </TabContainer>
            </div>
          )}
        </div>
      </If>
    );
  }
}

const VerticalTabs = withStyles((theme) => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles((theme) => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",marginRight:8
  },
  icon: {
    display: "inline-black",
    marginRight:8
  },
}))(Tab);

// function TabContainer(props) {
//   return (
//     <Typography component="div" className="verticaltab-innercont" style={{ overflow: 'auto' }}>
//         {props.children}
//     </Typography>
//   );
// }

function TabContainer(props) {
  return (
    <Typography
      component="div"
      className="verticaltab-innercont"
      style={{ overflow: "auto" }}
    >
      {props.children}
    </Typography>
  );
}

export default DocumentationTabs;
